import _styled, { default as _styled2, default as _styled3, default as _styled4 } from "styled-components";
import { useHardwareComparison } from "~/features/blocks/inventory/hardware-comparison-table/context";
import { translations } from "~/features/blocks/inventory/hardware-comparison-table/utils";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import { useLocale } from "~/features/i18n/use-locale";
import { Icon } from "~/features/ui/icon";
import EyeOff from "~/public/icons/eye-off.svg";
import EyeOn from "~/public/icons/eye-on.svg";
import { Link } from "~/features/ui/link";
import { Tag } from "~/features/ui/tag";
import { type HardwareComparisonProduct } from "~/features/blocks/inventory/hardware-comparison-table";
export function CompressedProduct(props: {
  product: HardwareComparisonProduct;
  isSmall?: boolean;
  isHidden?: boolean;
}) {
  const {
    toggleProductColumn
  } = useHardwareComparison();
  const locale = useLocale();
  return <_StyledDiv>
      <_StyledLink href={props.product?.url}>
        <Asset asset={props.product?.productImage as AssetProps["asset"]} imageProps={{
        fit: "cover",
        width: 72,
        ratio: "1/1"
      }} />
      </_StyledLink>
      <_StyledH>{props.product?.title}</_StyledH>
      <Tag as="button" variant={props.isSmall && !props.isHidden ? "solid-green" : "solid-light-grey"} onClick={() => {
      if (props.product.id) {
        toggleProductColumn(props.product.id);
      }
    }}>
        <_StyledSpan>
          {!props.isSmall && translations["show"][locale]} <Icon icon={props.isHidden ? EyeOff : EyeOn} size="16" />
        </_StyledSpan>
      </Tag>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-f99tcc-0"
})({
  "display": "grid",
  "height": "7.4rem",
  "width": "100%",
  "gridTemplateColumns": "4.8rem 1fr max-content",
  "alignItems": "center",
  "gap": "1.6rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(239 239 246 / var(--tw-bg-opacity))",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem"
});
var _StyledLink = _styled2(Link).withConfig({
  componentId: "sc-sf-f99tcc-1"
})({
  "position": "relative",
  "height": "100%",
  "width": "100%"
});
var _StyledH = _styled3("h2").withConfig({
  componentId: "sc-sf-f99tcc-2"
})({
  "fontSize": "1.6rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.016rem",
  "fontWeight": "400"
});
var _StyledSpan = /*#__PURE__*/_styled4("span").withConfig({
  displayName: "compressed-product___StyledSpan",
  componentId: "sc-174kndx-0"
})({
  "display": "flex",
  "alignItems": "center",
  "gap": "0.8rem",
  "fontFamily": "Saans, ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\""
});